import React from "react";
import classNames from "classnames";
import {Product} from "../../model/types";
import {Svg} from "@/shared/ui/Svg";
import {declOfNum} from "@/shared/lib/number/declOfNum";
import styles from "./ProductRating.module.scss";

type Props = {
    product: Product;
};

export const ProductRating = ({product}: Props) => {
    const hasRating = !!product.ratingCount;

    return (
        <div className={styles.container}>
            <Svg id={`star`} className={classNames(styles.svg, {[styles.active]: hasRating})} />
            {hasRating ? (
                <>
                    <div className={styles.average}>{product.ratingAVG ?? 0}</div>
                    <div className={styles.dot}></div>
                    <div className={styles.count}>
                        {product.ratingCount} {declOfNum(product.ratingCount, [' отзыв', ' отзыва', ' отзывов'])}
                    </div>
                </>
            ) : (
                <p className={styles.notRatingText}>Нет оценок</p>
            )}
        </div>
    );
};
